import { Dialog, IconButton, Typography, Box, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Loader } from "./Loader";

export const CommonDialog = ({
  open,
  onClose,
  title,
  loading,
  children,
  onSave,
  showActions = true,
}) => {
  return (
    <Dialog
      fullScreen
      open={open}
      PaperProps={{
        sx: { display: "flex", flexDirection: "column", m: 0, p: 0 },
      }}
    >
      {loading && <Loader loading={loading} />}

      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 2,
          py: "6px",
          borderBottom: "1px solid #e0e0e0",
          backgroundColor: "#f8f9fa",
        }}
      >
        <Typography
          sx={{ fontSize: "16px", fontWeight: 500, color: "#2782EC" }}
        >
          {title}
        </Typography>

        <Box sx={{ flexGrow: 1 }} />

        <IconButton
          onClick={onClose}
          disableRipple
          sx={{
            width: 20,
            height: 20,
            borderRadius: "2px",
            backgroundColor: "#8c8c8c",
            color: "#fff",
            p: 0,
            "&:hover": {
              backgroundColor: "#7a7a7a",
            },
          }}
        >
          <CloseIcon sx={{ fontSize: "16px" }} />
        </IconButton>
      </Box>

      {/* Body */}
      <Box sx={{ height: "100vh", backgroundColor: "#fff", p: 4 }}>
        {children}

        {/* 🔥 Common Buttons */}
        {showActions && (
          <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
            <Button
              variant="contained"
              size="small"
              sx={{
                backgroundColor: "#b3e5fc",
                color: "#000",
                textTransform: "none",
                boxShadow: "none",
                borderRadius: "4px",
                minWidth: "100px",
                height: "30px",
                px: 1,
                fontSize: "11px",
                "&:hover": {
                  backgroundColor: "#81d4fa",
                  boxShadow: "none",
                },
              }}
              onClick={onSave}
              disabled={loading}
            >
              Save & Close
            </Button>

            <Button
              variant="contained"
              size="small"
              sx={{
                backgroundColor: "#EFDBE3",
                color: "#d32f2f",
                textTransform: "none",
                boxShadow: "none",
                borderRadius: "4px",
                minWidth: "100px",
                height: "30px",
                px: 1,
                fontSize: "11px",
                "&:hover": {
                  backgroundColor: "#f48fb1",
                  boxShadow: "none",
                },
              }}
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </Button>
          </Box>
        )}
      </Box>
    </Dialog>
  );
};
